import errorCodes from 'helpers/enums/errorCodes'
import actionTypes from 'redux/actions/actionTypes'
import standAloneActivityTypes from 'helpers/enums/standAloneActivityTypes'
import modalTypes from 'helpers/enums/modalTypes'
import referenceMediaTypes from 'helpers/enums/referenceMediaTypes'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import { getFlag } from 'helpers/featureFlags/provider'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'

function openModal(state, modalName, params) {
	let newState
	if (!(state.find(modal => modal.modalName === modalName))) {
		newState = [...state, { modalName, visible: true, params }]
	} else {
		newState = state
	}
	return newState.map(modal => {
		if (modal.modalName === modalName && modal.visible === false) {
			return Object.assign({}, modal, { visible: true })
		} else if (modal.modalName !== modalName && modal.visible === true) {
			return Object.assign({}, modal, { visible: false })
		} else {
			return modal
		}
	})
}

function closeModal(state, modalName) {
	const index = state.findIndex(modal => modal.modalName === modalName)
	const newState = [
		...state.slice(0, index),
		...state.slice(index + 1),
	]
	if (newState.length) {
		return newState.map((element, index, array) => {
			if (index === array.length -1) {
				return Object.assign({}, element, { visible: true })
			} else {
				return element
			}
		})
	} else {
		return newState
	}
}

function handleHomeworkLaunch(state, action) {
	// First case is any user that can launch a self paced
	// Second case is a gold trial user
	if (
		(
			action.type === actionTypes.MY_LIBRARY_HOMEWORK_FETCHED
			&& action.payload.hwTrial.showMessage !== '1'
		)
		||
		(
			action.type === actionTypes.MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED
			&& action.button.action === '4'
		)
	) {
		const sessionData =
			action.type === actionTypes.MY_LIBRARY_HOMEWORK_FETCHED
				? action.payload
				: action.sessionData

		if (sessionData.activePins.length === 0) {
			return openModal(
				state,
				modalTypes.MY_LIBRARY_LAUNCH_HOMEWORK,
				{
					sessionUid: sessionData.session_uid,
					presentationUid: action.presentationUid,
				}
			)
		} else if (sessionData.activePins.length > 0) {
			return openModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_STUDENT_PACED,
				{
					presentationUid: action.presentationUid,
				}
			)
		}
	} else {
		return state
	}
}

function openQlOnInitialize(state, action) {
	if (action.newQuickLaunchActivity === standAloneActivityTypes.TIMER) {
		return openModal(state, modalTypes.QUICK_LAUNCH_TIMER_CREATE)
	} else if (action.newQuickLaunchActivity === standAloneActivityTypes.COLLABORATE) {
		return openModal(state, modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE)
	} else {
		return state
	}
}

function openLiveActiveCodesModal(state, action) {
	const newState = closeModal(state, modalTypes.MY_LIBRARY_TEACH_MODAL)
	if (action.hasMultiplePins) {
		return openModal(
			newState,
			modalTypes.LESSON_CODES_LAUNCH_LIVE_SESSION,
			{ presentation_uid: action.presentationUid, hasZoom: action.hasZoom }
		)
	}
	return newState
}

function handleDrawItReferenceMediaOpen(state, action) {
	if (getFlag(featureFlagsTypes.AUDIO_RECORDER_DRAWIT) &&
		action.mediaType === referenceMediaTypes.AUDIO_RECORDER) {
		return state
	} else {
		return openModal(
			state,
			modalTypes.DRAW_IT_REFERENCE_MEDIA_PICKER,
			{mediaType: action.mediaType}
		)
	}
}

const modalReducer = (state = [], action) => {

	switch (action.type) {
		case actionTypes.OPEN_MODAL:
			return openModal(state, action.modalName, action.params)
		case actionTypes.CLOSE_MODAL:
			return closeModal(state, action.modalName)
		case actionTypes.BINDERS_SAVE_LESSONS_SUCCESS:
		case actionTypes.BINDERS_PICKER_CANCEL:
			return closeModal(state, modalTypes.BINDERS_LESSONS_PICKER)
		case actionTypes.BINDERS_BINDER_CREATE_END:
		case actionTypes.BINDERS_BINDER_CREATE_NEW:
			return closeModal(state, modalTypes.BINDERS_CREATE)
		case actionTypes.BINDERS_CANCEL_NOTES:
			return closeModal(state, modalTypes.BINDERS_NOTES)
		case actionTypes.PRIVATE_LIBRARY_EDIT_SETTINGS:
			return openModal(state, modalTypes.PRIVATE_LIBRARY_SETTINGS)
		case actionTypes.PRIVATE_LIBRARY_FOLDER_PROMPT_ADD_LESSON:
			return openModal(
				state,
				modalTypes.PRIVATE_LIBRARY_ADD_TO_FOLDER,
				{entity: action.entity}
			)
		case actionTypes.PRIVATE_LIBRARY_FIND_LESSONS_PREVIEW:
			return openModal(
				state,
				modalTypes.LESSON_PREVIEW,
				{
					entityUID: action.entity,
					bundleId: action.bundleId,
					privateLibraryId: action.privateLibraryId,
				}
			)
		case actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON_CANCEL:
		case actionTypes.PRIVATE_LIBRARY_FOLDER_ADD_LESSON_SUCCESS:
			return closeModal(state, modalTypes.PRIVATE_LIBRARY_ADD_TO_FOLDER)
		case actionTypes.PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL:
		case actionTypes.PRIVATE_LIBRARY_OPEN_RENAME_FOLDER_MODAL:
			return openModal(state, modalTypes.PRIVATE_LIBRARY_NAME_FOLDER)
		case actionTypes.PRIVATE_LIBRARY_SETTINGS_SUCCESS:
			return closeModal(state, modalTypes.PRIVATE_LIBRARY_SETTINGS)
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_SUCCESS:
		case actionTypes.PRIVATE_LIBRARY_NAME_FOLDER_CANCEL:
			return closeModal(state, modalTypes.PRIVATE_LIBRARY_NAME_FOLDER)
		case actionTypes.PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL_WITH_ENTITY:
			state = closeModal(state, modalTypes.PRIVATE_LIBRARY_ADD_TO_FOLDER)
			return openModal(state, modalTypes.PRIVATE_LIBRARY_NAME_FOLDER)
		case actionTypes.PRIVATE_LIBRARY_OPEN_ADD_LESSONS_TO_FOLDER:
			return openModal(state, modalTypes.PRIVATE_LIBRARY_LESSONS_PICKER)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_ADD_SUCCESS:
		case actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_CANCEL:
			return closeModal(state, modalTypes.PRIVATE_LIBRARY_LESSONS_PICKER)
		case actionTypes.ADMIN_ONBOARDING_ADD_USER_SUCCESS:
			return closeModal(state, modalTypes.ADMIN_ONBOARDING_ADD_USER)
		case actionTypes.NAVIGATION_MENU_MAIN_UPDATE_PROFILE_IMAGE_SELECTED:
		case actionTypes.MY_ACCOUNT_AVATAR_CLICK:
			return openModal(state, modalTypes.MY_ACCOUNT_NEARPOD_PICKER)
		case actionTypes.MY_ACCOUNT_NEARPOD_PICKER_CANCEL:
		case actionTypes.MY_ACCOUNT_UPLOAD_PROFILE_IMAGE:
		case actionTypes.MY_ACCOUNT_UPLOAD_PROFILE_IMAGE_ERROR:
			return closeModal(state, modalTypes.MY_ACCOUNT_NEARPOD_PICKER)
		case actionTypes.PLAYGROUND_NEARPOD_PICKER_MODAL_OPEN:
			return openModal(
				state,
				modalTypes.PLAYGROUND_NEARPOD_PICKER,
				{pickerType: action.pickerType}
			)
		case actionTypes.PLAYGROUND_NEARPOD_PICKER_CANCEL:
		case actionTypes.PLAYGROUND_NEARPOD_PICKER_PICK:
			return closeModal(state, modalTypes.PLAYGROUND_NEARPOD_PICKER)
		case actionTypes.BINDERS_SELECT_LESSONS:
			state = closeModal(state, modalTypes.BINDERS_LESSONS_PICKER)
			return openModal(state, modalTypes.BINDERS_NOTES)
		case actionTypes.BINDERS_SHOW_LESSONS_CODE:
			return openModal(state, modalTypes.BINDERS_LESSON_CODES)
		case actionTypes.BINDERS_CLOSE_CODES_MODAL:
			return closeModal(state, modalTypes.BINDERS_LESSON_CODES)
		case actionTypes.POLL_EDIT_SETTINGS:
			return openModal(state, modalTypes.POLL_SETTINGS)
		case actionTypes.POLL_SAVE_SETTINGS_ERROR:
		case actionTypes.POLL_SAVE_SETTINGS_SUCCESS:
			return closeModal(state, modalTypes.POLL_SETTINGS)
		case actionTypes.POLL_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN:
			return openModal(
				state,
				modalTypes.POLL_NEARPOD_PICKER,
				{
					mediaType: action.mediaType,
					questionId: action.questionId,
				}
			)
		case actionTypes.POLL_NEARPOD_PICKER_CANCEL:
		case actionTypes.POLL_UPLOAD_REFERENCE_MEDIA:
		case actionTypes.POLL_UPLOAD_REFERENCE_MEDIA_ERROR:
			return closeModal(state, modalTypes.POLL_NEARPOD_PICKER)
		case actionTypes.QUIZ_REFERENCE_MEDIA_MENU_CLICK:
			return openModal(
				state,
				modalTypes.QUIZ_NEARPOD_PICKER,
				{
					mediaType: action.mediaType,
					questionId: action.questionId,
				}
			)
		case actionTypes.OEQ_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN:
			return openModal(
				state,
				modalTypes.OEQ_NEARPOD_PICKER,
				{mediaType: action.mediaType}
			)
		case actionTypes.OEQ_NEARPOD_PICKER_CANCEL:
		case actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA:
		case actionTypes.OEQ_UPLOAD_REFERENCE_MEDIA_ERROR:
			return closeModal(state, modalTypes.OEQ_NEARPOD_PICKER)
		case actionTypes.QUIZ_NEARPOD_PICKER_CANCEL:
		case actionTypes.QUIZ_UPLOAD_REFERENCE_MEDIA:
		case actionTypes.QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR:
			return closeModal(state, modalTypes.QUIZ_NEARPOD_PICKER)
		case actionTypes.MEDIA_PREVIEW:
			return openModal(
				state,
				modalTypes.MEDIA_PREVIEW,
				{
					mediaType: action.mediaType,
					mediaVersions: action.mediaVersions,
				}
			)
		case actionTypes.MATCHING_PAIRS_CT_ADD_PAIR:
		case actionTypes.MATCHING_PAIRS_CT_EDIT_PAIR:
		case actionTypes.MATCHING_PAIRS_CT_PAIR_DELETE_REJECTED:
			return openModal(state, modalTypes.MATCHING_PAIRS_CT_PAIR)
		case actionTypes.MATCHING_PAIRS_CT_ADD_TIMER:
		case actionTypes.MATCHING_PAIRS_CT_EDIT_TIMER:
			return openModal(state, modalTypes.MATCHING_PAIRS_CT_TIMER)
		case actionTypes.MATCHING_PAIRS_CT_SAVE_TIMER:
		case actionTypes.MATCHING_PAIRS_CT_CANCEL_TIMER:
			return closeModal(state, modalTypes.MATCHING_PAIRS_CT_TIMER)
		case actionTypes.QUIZ_ADD_TIMER:
		case actionTypes.QUIZ_EDIT_TIMER:
			return openModal(state, modalTypes.QUIZ_TIMER)
		case actionTypes.GAME_QUESTION_TIMER_EDIT:
			return openModal(
				state,
				modalTypes.GAME_TIMER_QUESTION,
				{
					id: action.id,
					value: action.value,
				}
			)
		case actionTypes.GAME_QUESTION_TIMER_CANCEL:
		case actionTypes.GAME_QUESTION_TIMER_SAVE:
			return closeModal(state, modalTypes.GAME_TIMER_QUESTION)
		case actionTypes.QUIZ_SAVE_TIMER:
		case actionTypes.QUIZ_CANCEL_TIMER:
			return closeModal(state, modalTypes.QUIZ_TIMER)
		case actionTypes.MATCHING_PAIRS_CT_PAIR_ADD_AN_IMAGE:
			return openModal(
				state,
				modalTypes.MATCHING_PAIRS_ADD_IMAGE_PICKER,
				{
					mediaType: 'image',
					cardName: action.cardName,
					clientId: action.clientId,
				}
			)
		case actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICKER_CLOSE:
		case actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICKED:
		case actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_ERROR:
			return closeModal(state, modalTypes.MATCHING_PAIRS_ADD_IMAGE_PICKER)
		case actionTypes.MATCHING_PAIRS_CT_PAIR_SAVE_VALIDATE_SUCCESS:
		case actionTypes.MATCHING_PAIRS_CT_DELETE_PAIR:
			return closeModal(state, modalTypes.MATCHING_PAIRS_CT_PAIR)
		case actionTypes.MATCHING_PAIRS_CT_OPEN_PREVIEW:
			return openModal(state, modalTypes.MATCHING_PAIRS_CT_PREVIEW)
		case actionTypes.MATCHING_PAIRS_CT_CLOSE_PREVIEW:
			return closeModal(state, modalTypes.MATCHING_PAIRS_CT_PREVIEW)
		case actionTypes.STOREFRONT_ADD_LESSONS_SELECTED:
			return openModal(
				state,
				modalTypes.STOREFRONT_LESSONS_PICKER,
				{text: action.text}
			)
		case actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_OPEN:
			return openModal(
				state,
				modalTypes.STOREFRONT_GRADES_SUBJECTS_PICKER,
				{text: action.text}
			)
		case actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_CANCEL:
		case actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_CLOSE:
		case actionTypes.STOREFRONT_ADD_GRADES_SUBJECT_SAVE:
			return closeModal(
				state,
				modalTypes.STOREFRONT_GRADES_SUBJECTS_PICKER
			)
		case actionTypes.STOREFRONT_LESSONS_PICKER_ADD_SUCCESS:
		case actionTypes.STOREFRONT_LESSONS_PICKER_CANCEL:
		case actionTypes.STOREFRONT_LESSONS_PICKER_CLOSE:
			return closeModal(state, modalTypes.STOREFRONT_LESSONS_PICKER)
		case actionTypes.STOREFRONT_PREVIEW_LESSON:
			return openModal(
				state,
				modalTypes.LESSON_PREVIEW,
				{entityUID: action.entityUID}
			)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_PICKER_CLOSE:
			return closeModal(state, modalTypes.STOREFRONT_LESSONS_PICKER)
		case actionTypes.DRAW_IT_REFERENCE_MEDIA_MENU_CLICK:
			return handleDrawItReferenceMediaOpen(state, action)
		case actionTypes.DRAW_IT_SELECT_BACKGROUND_IMAGE:
			return openModal(
				state,
				modalTypes.DRAW_IT_BACKGROUND_IMAGE_PICKER,
				{mediaType: 'image'}
			)
		case actionTypes.DRAW_IT_CANCEL_REFERENCE_MEDIA_PICKER:
		case actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA:
		case actionTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR:
			return closeModal(state, modalTypes.DRAW_IT_REFERENCE_MEDIA_PICKER)
		case actionTypes.DRAW_IT_CANCEL_BACKGROUND_IMAGE_PICKER:
		case actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE:
		case actionTypes.DRAW_IT_UPLOAD_BACKGROUND_IMAGE_ERROR:
			return closeModal(state, modalTypes.DRAW_IT_BACKGROUND_IMAGE_PICKER)
		case actionTypes.PRIVATE_LIBRARY_SWITCH_LIBRARY:
			return openModal(state, modalTypes.SWITCH_LIBRARY)

		case actionTypes.MY_LIBRARY_HOMEWORK_FETCHED:
		case actionTypes.MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED:
			return handleHomeworkLaunch(state, action)
		case actionTypes.MY_LIBRARY_SESSION_FETCHED:
			if (action.payload.multiplePins === true) {
				return openModal(
					state,
					modalTypes.LESSON_CODES_LAUNCH_LIVE_SESSION,
					{presentation_uid: action.presentation_uid}
				)
			} else {
				return state
			}
		case actionTypes.MY_LIBRARY_STUDENT_PACED_CODES_CLOSED:
			return closeModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_STUDENT_PACED
			)
		case actionTypes.MY_LIBRARY_LAUNCH_NEW_HOMEWORK:
			state = closeModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_STUDENT_PACED
			)
			return closeModal(state, modalTypes.MY_LIBRARY_TEACH_MODAL)
		case actionTypes.MY_LIBRARY_SHARE_ACTIVE_STUDENT_PACED_SESSION:
			state = closeModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_STUDENT_PACED
			)
			return openModal(
				state,
				modalTypes.MY_LIBRARY_LAUNCH_HOMEWORK,
				{
					sessionUid: action.sessionData.session_uid,
					presentationUid: action.presentationUid,
				}
			)
		case actionTypes.MY_LIBRARY_LIVE_SESSION_CODES_CLOSED:
		case actionTypes.MY_LIBRARY_RESUME_ACTIVE_LIVE_SESSION:
			return closeModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_LIVE_SESSION
			)
		case actionTypes.MY_LIBRARY_LAUNCH_NEW_LIVE_SESSION:
			state = closeModal(
				state,
				modalTypes.LESSON_CODES_LAUNCH_LIVE_SESSION
			)
			return closeModal(state, modalTypes.MY_LIBRARY_TEACH_MODAL)
		case actionTypes.MY_LIBRARY_SAVE_CHANGES_FETCHED:
			if (action.saveResponse.error_code === 2) {
				return openModal(
					state,
					modalTypes.SAVE_CHANGES,
					{entity: action.entity}
				)
			} else {
				return state
			}
		case actionTypes.MY_LIBRARY_CLOSE_SAVE_CHANGES_MODAL:
		case actionTypes.MY_LIBRARY_LESSON_DATA_SAVED:
			return closeModal(state, modalTypes.SAVE_CHANGES)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER:
			return openModal(
				state,
				modalTypes.MY_LIBRARY_ADD_TO_FOLDER,
				{entity: action.lesson}
			)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_CANCELLED:
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_FOLDER_SELECTED:
			return closeModal(state, modalTypes.MY_LIBRARY_ADD_TO_FOLDER)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_NEW_FOLDER:
			state = closeModal(state, modalTypes.MY_LIBRARY_ADD_TO_FOLDER)
			return openModal(state, modalTypes.MY_LIBRARY_NAME_FOLDER)
		case actionTypes.MY_LIBRARY_FOLDER_RENAME:
		case actionTypes.MY_LIBRARY_ADD_FOLDER:
			return openModal(state, modalTypes.MY_LIBRARY_NAME_FOLDER)
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_SUCCESS:
		case actionTypes.MY_LIBRARY_ADD_OR_UPDATE_FOLDER_CANCELLED:
			return closeModal(state, modalTypes.MY_LIBRARY_NAME_FOLDER)
		case actionTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER:
			return openModal(
				state,
				modalTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER,
				{folder: action.folder}
			)
		case actionTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER_CANCELLED:
		case actionTypes.MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS_SUCCESS:
			return closeModal(
				state,
				modalTypes.MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER
			)
		case actionTypes.MY_LIBRARY_SHARE_FOLDER_DATA_LOADED:
		case actionTypes.SHARE_VIEW_DATA_LOADED:
			return openModal(state, modalTypes.SHARE, {
				tab: 'email',
				entityUID: action.entityUID,
				entityType: action.entityType,
				libraryID: 0,
			})
		case actionTypes.SHARE_VIEW_DATA_FAILED:
			return closeModal(state, modalTypes.SHARE)
		case actionTypes.MY_LIBRARY_SESSION_LTI_CANVAS_SAVED:
			if (action.teams) {
				return openModal(
					state,
					modalTypes.MY_LIBRARY_LAUNCH_SESSION_TEAMS,
					{
						presentationUid: action.presentationUid,
						payload: action.payload,
						sessionType: action.sessionType,
					}
				)
			} else {
				return state
			}
		case actionTypes.MY_LIBRARY_CLOSE_LAUNCH_SESSION_TEAMS:
			return closeModal(state, modalTypes.MY_LIBRARY_LAUNCH_SESSION_TEAMS)
		case actionTypes.PRIVATE_LIBRARY_LESSONS_ACCESS_DENIED:
			if (action.error.error_code === errorCodes.PRIVATE_LIBRARY_CP_ACCESS_DENIED) {
				return openModal(
					state,
					modalTypes.UNLOCK_LESSONS,
					{
						learnMoreRedirect: action.error.learnMoreRedirect,
						sampleLessonsRedirect: action.error.sampleLessonsRedirect,
						privateLibraryTitle: action.error.privateLibraryTitle,
					}
				)
			} else {
				return state
			}
		case actionTypes.ADMIN_ONBOARDING_INVITE_COLLEAGUE:
			return openModal(state, modalTypes.ADMIN_ONBOARDING_ADD_USER)
		case actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_MODAL_OPEN:
			return openModal(state, modalTypes.REFER_CONTACT)
		case actionTypes.ADMIN_ONBOARDING_REFER_CONTACT_MODAL_CLOSE:
		case actionTypes.ADMIN_ONBOARDING_REFER_A_CONTACT_SENT:
			return closeModal(state, modalTypes.REFER_CONTACT)
		case actionTypes.POLL_ADD_TIMER:
		case actionTypes.POLL_EDIT_TIMER:
			return openModal(state, modalTypes.POLL_CT_TIMER)
		case actionTypes.POLL_SAVE_TIMER:
		case actionTypes.POLL_CANCEL_TIMER:
			return closeModal(state, modalTypes.POLL_CT_TIMER)
		case actionTypes.OEQ_ADD_TIMER:
		case actionTypes.OEQ_EDIT_TIMER:
			return openModal(state, modalTypes.OEQ_CT_TIMER)
		case actionTypes.OEQ_SAVE_TIMER:
		case actionTypes.OEQ_CANCEL_TIMER:
			return closeModal(state, modalTypes.OEQ_CT_TIMER)
		case actionTypes.DRAW_IT_ADD_TIMER:
		case actionTypes.DRAW_IT_EDIT_TIMER:
			return openModal(state, modalTypes.DRAW_IT_CT_TIMER)
		case actionTypes.DRAW_IT_SAVE_TIMER:
		case actionTypes.DRAW_IT_CANCEL_TIMER:
			return closeModal(state, modalTypes.DRAW_IT_CT_TIMER)
		case actionTypes.QUICK_LAUNCH_TIMER_CREATE:
			return openModal(state, modalTypes.QUICK_LAUNCH_TIMER_CREATE)
		case actionTypes.QUICK_LAUNCH_TIMER_CREATE_SAVE:
			return closeModal(state, modalTypes.QUICK_LAUNCH_TIMER_CREATE)
		case actionTypes.QUICK_LAUNCH_TIMER_CREATE_CANCEL:
			return closeModal(state, modalTypes.QUICK_LAUNCH_TIMER_CREATE)
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE:
			return openModal(state, modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE)
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_LAUNCH:
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_CANCEL:
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CANCEL_ACTIVITY:
		case actionTypes.QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_FAILED:
			return closeModal(state, modalTypes.QUICK_LAUNCH_COLLABORATE_CREATE)
		case actionTypes.MY_LIBRARY_INITIALIZE:
			return openQlOnInitialize(state, action)
		case actionTypes.MY_ACCOUNT_SHOW_PASSWORD_FORM:
			return openModal(state, modalTypes.SHOW_PASSWORD_FORM)
		case actionTypes.MY_ACCOUNT_CLOSE_PASSWORD_FORM:
			return closeModal(state, modalTypes.SHOW_PASSWORD_FORM)
		case actionTypes.GAME_UPLOAD_ANSWER_MEDIA_ADD:
			return openModal(
				state,
				modalTypes.GAME_IMAGE_ANSWER_PICKER,
				{
					questionId: action.questionId,
					answerId: action.answerId,
				}
			)
		case actionTypes.GAME_UPLOAD_ANSWER_MEDIA_SELECTED:
		case actionTypes.GAME_UPLOAD_ANSWER_MEDIA_FAILED:
		case actionTypes.GAME_UPLOAD_ANSWER_MEDIA_CANCELLED:
			return closeModal(state, modalTypes.GAME_IMAGE_ANSWER_PICKER)
		case actionTypes.GAME_UPLOAD_QUESTION_MEDIA_ADD:
			return openModal(
				state,
				modalTypes.GAME_QUESTION_MEDIA_PICKER,
				{
					mediaType: action.mediaType,
					questionId: action.questionId,
				}
			)
		case actionTypes.GAME_UPLOAD_QUESTION_MEDIA_SELECTED:
		case actionTypes.GAME_UPLOAD_QUESTION_MEDIA_ERROR:
		case actionTypes.GAME_UPLOAD_QUESTION_MEDIA_CANCELLED:
			return closeModal(state, modalTypes.GAME_QUESTION_MEDIA_PICKER)
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED:
			if (action.error.error_code === errorCodes.ADD_TO_PL_CHOOSE_FOLDER) {
				const params = {
					libraryType: action.library_type,
					lesson: action.lesson,
				}
				return openModal(state, modalTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY, params)
			} else {
				return state
			}
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_CLOSE_SELECTED:
		case actionTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_ADD_SELECTED:
			return closeModal(state, modalTypes.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY)
		case actionTypes.MY_LIBRARY_TEACH_LESSON_SELECTED:
			return openModal(
				state,
				modalTypes.MY_LIBRARY_TEACH_MODAL,
				{
					entity: action.entity,
				}
			)
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_CLOSE_SELECTED:
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_SETTINGS_SELECTED:
		case actionTypes.MY_LIBRARY_LAUNCH_FRONT_OF_THE_CLASSROOM:
		case actionTypes.MY_LIBRARY_LAUNCH_HOMEWORK:
			// If Teach Button and Modal FF is OFF, it won't find the modal
			if (state.find(modal => modal.modalName === modalTypes.MY_LIBRARY_TEACH_MODAL)) {
				return closeModal(state, modalTypes.MY_LIBRARY_TEACH_MODAL)
			}
			return state
		case actionTypes.MY_LIBRARY_TEACH_LESSON_MODAL_LIVE_ACTIVE_CODES_SELECTED:
			return openLiveActiveCodesModal(state, action)
		case actionTypes.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_FAILED:
			if (action.error.error_code === localErrorCodes.GOOGLE_SLIDES_UNAUTHORIZED_USER) {
				return openModal(state, modalTypes.GOOGLE_SLIDES_UNAUTHORIZED_CREATE)
			}
			return state
		case actionTypes.PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED:
		case actionTypes.PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE:
			return closeModal(state, modalTypes.GOOGLE_SLIDES_UNAUTHORIZED_CREATE)
		default:
			return state
	}

}

export default modalReducer
